import { kebabCase } from 'lodash';

/**
 * Generates an HTML-friendly anchor id from a title using the first N words.
 * Useful for hyperlinking to headings (e.g. table of contents, in-page links).
 *
 * @param title - The title text
 * @param wordCount - Number of words to use (default 3)
 * @returns kebab-case id suitable for use as element id, or empty string if title is empty
 */
export const getAnchorIdFromTitle = (title: string, wordCount = 3): string => {
  const words = title.trim().split(/\s+/).filter(Boolean).slice(0, wordCount);

  if (words.length === 0) return '';

  return kebabCase(words.join(' '));
};
